import { render, staticRenderFns } from "./VsPhone.vue?vue&type=template&id=0133658a&lang=html"
import script from "./VsPhone.vue?vue&type=script&lang=js"
export * from "./VsPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports